export default __webpack_public_path__ + "static/media/notification-icon.b1d3ddd2.svg";